import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export interface IDeductionFieldConfig {
  field_name: string;
  field_type:
    | "number"
    | "string"
    | "contribution"
    | "enum"
    | "override"
    | "document";
  label: string;
  contribution_type?: string[];
  options?: string[];
}

export interface IDeductionTypeConfig {
  deductionType: string;
  label: string;
  fields: IDeductionFieldConfig[];
}

export const getDeductionTypeConfig = (axios: IAxiosInstance) => {
  return async (deductionType: string): Promise<IDeductionTypeConfig> => {
    const response = await axios.noRetry.get<
      IApiResponse<IDeductionTypeConfig>
    >("/private/api/deduction-type-config", {
      params: { deduction_type: deductionType },
    });
    const data = response.data;

    if (data.success) {
      return data.data;
    }

    throw new Error("Failed to fetch deduction type config");
  };
};
